import React from "react";

import { WebsiteInformation } from "types";

import styles from "./websitePreview.module.scss";

type WebsitePreviewProps = {
	websiteInformation: WebsiteInformation;
};

const WebsitePreview = ({
	websiteInformation: { url = "", title = "", screenshotUrl = "" },
}: WebsitePreviewProps) => {
	return (
		<div className={styles.websitePreviewTooltip}>
			<a href={url} target="_blank" rel="noreferrer">
				<span className={styles.image}>
					<img alt={title} src={screenshotUrl} />
				</span>
				<span className={styles.title}>{title}</span>
				<span className={styles.url}>{url}</span>
			</a>
		</div>
	);
};

export default WebsitePreview;
